// @ts-nocheck
import React, {useCallback, useEffect, useState} from 'react'
import moment from 'moment'
import AffiliateShell from './components/AffiliateShell'
import AffiliateMeetingModal from './components/AffiliateMeetingModal'
import {AFF, card} from './components/affiliateTheme'
import {cancelAffiliateMeeting, getAffiliateMeetings} from './core/_requests'

const STATUS = {
  scheduled: {label: 'מתוזמן', cls: 'badge-light-primary'},
  completed: {label: 'הושלם', cls: 'badge-light-success'},
  cancelled: {label: 'בוטל', cls: 'badge-light-danger'},
  no_show: {label: 'לא הגיע', cls: 'badge-light-warning'},
}

const TYPE_LABEL = {
  onboarding_new: 'אונבורדינג (לקוח חדש)',
  onboarding: 'אונבורדינג / הדרכה',
  technical: 'תמיכה טכנית',
  followup: 'מעקב',
  sales: 'מכירות',
  other: 'אחר',
}

const AffiliateMeetingsWrapper = () => {
  const [meetings, setMeetings] = useState([])
  const [loading, setLoading] = useState(true)
  const [booking, setBooking] = useState(false)
  const [cancelling, setCancelling] = useState(null)

  const load = useCallback(() => {
    setLoading(true)
    getAffiliateMeetings()
      .then((r) => setMeetings(r.data?.meetings || []))
      .catch(() => setMeetings([]))
      .finally(() => setLoading(false))
  }, [])

  useEffect(load, [load])

  const cancel = async (m) => {
    if (!window.confirm(`לבטל את הפגישה של ${m.customer?.name || 'הלקוח'} ב-${moment(m.meeting_date).format('DD/MM HH:mm')}?`)) return
    setCancelling(m._id)
    try {
      await cancelAffiliateMeeting(m._id)
      load()
    } catch (e) {
      alert(e?.response?.data?.error || 'ביטול הפגישה נכשל')
    }
    setCancelling(null)
  }

  const now = moment()
  const upcoming = meetings.filter((m) => m.status === 'scheduled' && moment(m.meeting_date).isAfter(now))
  const past = meetings.filter((m) => !(m.status === 'scheduled' && moment(m.meeting_date).isAfter(now)))

  const Row = ({m, isPast}) => {
    const s = STATUS[m.status] || STATUS.scheduled
    return (
      <tr>
        <td style={{paddingInlineStart: 24, fontWeight: 600, color: AFF.ink}}>
          {moment(m.meeting_date).format('DD/MM/YYYY')}
          <span style={{color: AFF.muted, fontWeight: 500}}> · {moment(m.meeting_date).format('HH:mm')}</span>
        </td>
        <td style={{color: AFF.ink}}>
          {m.customer?.name || '—'}
          {m.customer?.is_lead && <span className='badge badge-light-warning ms-2'>ליד</span>}
          {m.customer?.phone && <div style={{color: AFF.muted, fontSize: 12}}>{m.customer.phone}</div>}
        </td>
        <td style={{color: AFF.ink}}>{m.admin?.name || '—'}</td>
        <td style={{color: AFF.muted, fontSize: 13}}>{TYPE_LABEL[m.meeting_type] || m.meeting_type}</td>
        <td><span className={`badge ${s.cls}`}>{s.label}</span></td>
        <td className='text-end' style={{paddingInlineEnd: 24}}>
          {!isPast && m.booked_by_me && (
            <button
              className='btn btn-sm btn-light-danger'
              onClick={() => cancel(m)}
              disabled={cancelling === m._id}
              title='בטל פגישה'
            >
              {cancelling === m._id ? <span className='spinner-border spinner-border-sm' /> : <i className='bi bi-x-circle' />}
            </button>
          )}
        </td>
      </tr>
    )
  }

  const Table = ({rows, isPast, empty}) => (
    <div style={{...card, padding: 0, marginBottom: 24}}>
      <div style={{padding: '18px 24px', borderBottom: `1px solid ${AFF.border}`, fontWeight: 700, color: AFF.ink}}>
        {isPast ? 'היסטוריית פגישות' : 'פגישות קרובות'}
        <span style={{color: AFF.muted, fontWeight: 500, fontSize: 13}}> · {rows.length}</span>
      </div>
      {rows.length === 0 ? (
        <div style={{textAlign: 'center', padding: 48, color: AFF.muted}}>
          <i className='bi bi-calendar-event' style={{fontSize: 36, opacity: 0.4, display: 'block', marginBottom: 10}} />
          {empty}
        </div>
      ) : (
        <div className='table-responsive'>
          <table className='table align-middle gy-4 mb-0'>
            <thead>
              <tr style={{color: AFF.muted, fontSize: 12, fontWeight: 700, textTransform: 'uppercase'}}>
                <th style={{paddingInlineStart: 24}}>מועד</th>
                <th>לקוח</th>
                <th>נציג</th>
                <th>סוג</th>
                <th>סטטוס</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.map((m) => <Row key={m._id} m={m} isPast={isPast} />)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )

  return (
    <AffiliateShell
      title='פגישות'
      subtitle='קבע פגישה לליד או ללקוח שהבאת — ישירות ביומן של צוות fbzipper.'
      action={
        <button className='btn btn-light fw-bold' onClick={() => setBooking(true)}>
          <i className='bi bi-calendar-plus me-1' /> קבע פגישה
        </button>
      }
    >
      {loading ? (
        <div style={{...card, padding: 60, textAlign: 'center', color: AFF.muted}}>
          <span className='spinner-border' />
        </div>
      ) : (
        <>
          <Table rows={upcoming} isPast={false} empty='אין פגישות קרובות. לחץ "קבע פגישה" כדי לתאם לליד או ללקוח שלך.' />
          <Table rows={past} isPast empty='עדיין לא היו פגישות.' />
        </>
      )}

      {booking && <AffiliateMeetingModal onClose={() => setBooking(false)} onBooked={load} />}
    </AffiliateShell>
  )
}

export default AffiliateMeetingsWrapper
